module.exports = __webpack_public_path__ + "5121bfcf27bcd1462127f32f254bfd16.MP3";